module.exports = __webpack_public_path__ + "img/Slice4.51f412d7.png";